import {
  Box,
  Button,
  Field,
  Flex,
  Heading,
  Input,
  Link,
  Spinner,
  Text,
} from "@chakra-ui/react";
import { ImageBasic } from "components/Image";
import { toaster } from "components/ui/toaster";
import useCheckMobileScreen from "hooks/useCheckMobileScreen";
import { useState } from "react";
import { api } from "services/api";

function Forgotpassword() {
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState("forgotpwd");
  const [email, setEmail] = useState("");

  const ismobile = useCheckMobileScreen();

  const handleSent = async () => {
    setIsLoading(true);
    const res = await api.forgotpassword({
      email: email,
    });
    setIsLoading(false);
    console.log("forgotpassword", res);

    if (res?.status === 200) {
      setStatus("linksendsucess");
    } else {
      toaster.create({
        title:
          res?.response?.data?.message || res?.data?.message || res?.message,
        type: res?.status === 200 ? "success" : "error",
      });
    }
  };

  if (status === "linksendsucess") {
    return (
      <Flex
        // h="100vh"
        // w={''}
        flex={1}
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        p={"2rem"}
        pb={"15%"}
      >
        <ImageBasic
          alignSelf={"center"}
          p={"30px"}
          src={"./img/img-brand-logo-dark.png"}
          h={"20rem"}
        />
        <Text fontWeight="bold" textAlign="center" color="fontdark">
          Your reset password link has been sent to your email.
        </Text>
        {/* <Text textAlign="center" color="primary" mt="5%">
          2024 - AU Warranties Ltd
        </Text> */}
      </Flex>
    );
  }

  return (
    <Flex
      // h="100vh"
      flex={1}
      flexDirection={"column"}
      justifyContent={"center"}
      alignItems={"center"}
      p={"2rem"}
    >
      <ImageBasic
        alignSelf={"center"}
        p={"30px"}
        src={"./img/img-brand-logo-dark.png"}
        h={"20rem"}
      />
      <Flex h={"2.5rem"} overflow={"hidden"}>
        {isLoading ? (
          <Spinner size="md" color="spinner" colorPalette={"spinner"} />
        ) : null}
      </Flex>
      <Heading textAlign={"center"} size="xl" color="fontdark" mt="2.5" mb="8">
        Auto Union Warranties Ltd Online Forgot Password Page
      </Heading>
      <Flex gap="4" w={ismobile ? "100%" : "400px"} flexDirection={"column"}>
        <Field.Root orientation="horizontal">
          <Field.Label textStyle={"md"}>Email</Field.Label>
          <Input
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            textStyle={"md"}
          />
        </Field.Root>

        <Button onClick={handleSent} bg="text" size="lg">
          Send Link
        </Button>

        <Field.Root orientation="horizontal">
          <Box />
          <Link color={"link"} href="/">
            login
          </Link>
        </Field.Root>
      </Flex>
      <Text textAlign="center" color="text" mt="5%">
        2024 - AU Warranties Ltd
      </Text>
    </Flex>
  );
}

export default Forgotpassword;
